// extracted by mini-css-extract-plugin
module.exports = {"kycHeader":"NeedKycBanner_kycHeader__fhXZZ","kycHeader__icon":"NeedKycBanner_kycHeader__icon__EI1Oo"};